import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import "./Datepicker.css";

function CustomIcon() {
  return <span className="icon-date" />;
}

export default function BasicDatePicker({
  disabled,
  label,
  isDateTime,
  style,
  value,
  onChange,
  name,
  isRequired = false,
  activateErrorHint = false,
  disablePastDates = false,
  disableFutureDates = false,
  minDate = null,
  maxDate = null,
}) {

  const shouldDisableDate = (date) => {
    const dayjsDate = dayjs(date);
    const isPreselectedDate = value && dayjsDate.isSame(dayjs(value), 'day');

    if (isPreselectedDate) {
      return false;
    }

    if (minDate && dayjsDate.isBefore(dayjs(minDate), 'day')) {
      return true;
    }

    if (maxDate && dayjsDate.isAfter(dayjs(maxDate), 'day')) {
      return true;
    }

    if (disablePastDates && dayjsDate.isBefore(dayjs(), 'day')) {
      return true;
    }
    if (disableFutureDates && dayjsDate.isAfter(dayjs(), 'day')) {
      return true;
    }

    return false;
  };

  return (
    <span className="date-component" style={style}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()} 
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker", "DateTimePicker"]}>
          {isDateTime ? (
            <DateTimePicker
              label={isRequired ? "*" + label : label}
              disabled={disabled}
              name={name}
              value={value ? dayjs(value) : null}
              views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
              onChange={onChange}
              timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
              slots={{ openPickerIcon: CustomIcon }}
              shouldDisableDate={shouldDisableDate}
              minDate={minDate ? dayjs(minDate) : null}
              maxDate={maxDate ? dayjs(maxDate) : null}
            />
          ) : (
            <DatePicker
              label={isRequired ? "*" + label : label}
              disabled={disabled}
              name={name}
              value={value ? dayjs(value) : null}
              onChange={onChange}
              slots={{ openPickerIcon: CustomIcon }}
              shouldDisableDate={shouldDisableDate}
              minDate={minDate ? dayjs(minDate) : null}
              maxDate={maxDate ? dayjs(maxDate) : null}
            />
          )}
        </DemoContainer>
      </LocalizationProvider>
    </span>
  );
}